export default __webpack_public_path__ + "static/media/building.4a4d4b0f.png";